import { render, staticRenderFns } from "./feeTable.vue?vue&type=template&id=636de5d0&scoped=true"
import script from "./feeTable.vue?vue&type=script&lang=js"
export * from "./feeTable.vue?vue&type=script&lang=js"
import style0 from "./feeTable.vue?vue&type=style&index=0&id=636de5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636de5d0",
  null
  
)

export default component.exports